import React, { FC, Fragment } from 'react';

import { useCapabilities } from 'hooks';

interface Props {
  name: string;
}

const Capability: FC<Props> = ({ name, children }) => {
  const capabilities = useCapabilities();
  const hasCapability = capabilities.includes(name);

  if (name.includes('[*]')) {
    const [baseCapability] = name.split('[*]');
    const hasMatch = !!capabilities.filter(capability => capability.includes(baseCapability))
      .length;

    if (hasMatch) {
      return <Fragment>{children}</Fragment>;
    }
  }

  if (!hasCapability) {
    return null;
  }

  return <Fragment>{children}</Fragment>;
};

export default Capability;
